import { SetDbLikelyCrashed, SetLoggedUser, SetUserChecked } from 'session/state/user/userActions';

export enum ActionType {
    SetLoggedUser,
    SetUserChecked,
    SetDbLikelyCrashed
}

export type StateActions = SetLoggedUser | SetUserChecked | SetDbLikelyCrashed;
